let deferredPrompt = null;
let isInstalled = false;
const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

const getStandaloneState = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

if (typeof window !== 'undefined') {
  isInstalled = getStandaloneState();

  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    deferredPrompt = event;
    notifyListeners();
  });

  window.addEventListener('appinstalled', () => {
    isInstalled = true;
    deferredPrompt = null;
    notifyListeners();
  });
}

export const getPwaInstallState = () => ({
  prompt: deferredPrompt,
  isInstalled,
});

export const subscribeToPwaInstallState = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const promptPwaInstall = async () => {
  if (!deferredPrompt) {
    return null;
  }

  const promptEvent = deferredPrompt;
  await promptEvent.prompt();
  const choice = await promptEvent.userChoice;
  isInstalled = choice?.outcome === 'accepted' || isInstalled;
  deferredPrompt = null;
  notifyListeners();
  return choice?.outcome;
};
